import { API_URL } from '../../constants';
import { StreamingOffer } from '../../interfaces/StreamingOffer.interface';

export const getStreamingOffer = async (): Promise<StreamingOffer[]> => {
  try {
    const response = await fetch(API_URL + '/api/streamingoffer');
    if (!response.ok) {
      throw new Error('Error fetching streamingoffers');
    }

    const streamingoffer: StreamingOffer[] = await response.json();
    return streamingoffer;
  } catch (error) {
    console.error('Error fetching streamingoffers', error);
    return [];
  }
};
